export default __webpack_public_path__ + "static/media/img-0073-uk-half-face.4eee6e24.png";